// extracted by mini-css-extract-plugin
export default {"list":"IjFkdw","item":"L3y2EP","label":"w4o3Kf","value":"ozjyB4"};